import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=1f2a6532&scoped=true&"
import script from "./favorite.vue?vue&type=script&lang=js&"
export * from "./favorite.vue?vue&type=script&lang=js&"
import style0 from "./favorite.css?vue&type=style&index=0&id=1f2a6532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a6532",
  null
  
)

export default component.exports